import { render, staticRenderFns } from "./OrderTotal.vue?vue&type=template&id=5f669b10"
import script from "./OrderTotal.vue?vue&type=script&lang=js"
export * from "./OrderTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports